// cols, rows, multiTasking, paging
import { useState, useEffect } from "react"
import { SyncOutlined } from "@ant-design/icons"

const Table = ({ cols, rows, multiTasking, handleRefresh }) => {
    const [rowsPerPage, setRowsPerPage] = useState(1) // Rows visible per page
    const [currentPage, setCurrentPage] = useState(1) // Current page number
    const [isSpinning, setIsSpinnning] = useState(false)

    useEffect(() => {
        const updateRowsPerPage = () => {
            const rowHeight = 50 // Define your row height in pixels
            const containerHeight = window.innerHeight - (multiTasking ? 320 : 250) // Account for header, footer, etc.
            const visibleRows = Math.floor(containerHeight / rowHeight)
            setRowsPerPage(visibleRows)
        }

        updateRowsPerPage()
        window.addEventListener("resize", updateRowsPerPage)
        window.removeEventListener("resize", updateRowsPerPage)
    }, [])
    if (!rows) {
        return
    }

    // Calculate the current page's data
    const startIndex = (currentPage - 1) * rowsPerPage
    const currentPageData = rows.slice(startIndex, startIndex + rowsPerPage)

    const totalPages = Math.ceil(rows.length / rowsPerPage)

    // Handle pagination controls
    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            setCurrentPage(newPage)
        }
    }

    const getPageNumbers = () => {
        const pages = []
        if (totalPages <= 5) {
            // Show all pages if they fit
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i)
            }
        } else {
            // Always show the first page
            pages.push(1)

            if (currentPage > 3) pages.push("...")

            for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
                pages.push(i)
            }

            if (currentPage < totalPages - 2) pages.push("...")

            // Always show the last page
            pages.push(totalPages)
        }
        return pages
    }

    return (
        <>
            <div className={multiTasking ? "lists" : "lists grid-rows-[16px_auto_50px]"}>
                {/* <!--! این دیو خالی باید باشه نباید حذف شه --> */}
                <div className="flex justify-end "></div>
                {/* <!--! این دیو خالی باید باشه نباید حذف شه --> */}
                <div class="list flex-grow">
                    <table>
                        <thead class="list-header">
                            <tr>
                                {handleRefresh ? (
                                    <th className="my-auto">
                                        <SyncOutlined
                                            className=""
                                            spin={isSpinning}
                                            onClick={async (e) => {
                                                setIsSpinnning(true)
                                                handleRefresh()
                                                setTimeout(() => setIsSpinnning(false), 1000)
                                            }}
                                        />
                                    </th>
                                ) : (
                                    <th>ردیف</th>
                                )}

                                {cols.map((item, index) => (
                                    <th colSpan={item.colSpan} key={index}>
                                        {item.name}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {currentPageData &&
                                currentPageData.map((item, index) => (
                                    <tr key={index}>
                                        {multiTasking ? (
                                            <td class="checkbox-holder ">
                                                <input
                                                    type="checkbox"
                                                    checked={multiTasking.selecteds.find((s) => s.id == item.id)}
                                                    onChange={(e) => {
                                                        let isChecked = e.target.checked
                                                        multiTasking.setSelecteds((selecteds) => {
                                                            let obj = [...selecteds]
                                                            if (isChecked) {
                                                                obj.push(item)
                                                            } else {
                                                                obj.splice(obj.indexOf(item), 1)
                                                            }

                                                            return obj
                                                        })
                                                    }}
                                                />
                                                {index + (currentPage - 1) * rowsPerPage + 1}
                                            </td>
                                        ) : (
                                            <>{index + (currentPage - 1) * rowsPerPage + 1}</>
                                        )}

                                        {Object.keys(item).map((key, index) => (
                                            <>{key == "id" ? null : <td key={index}>{item[key]}</td>}</>
                                        ))}
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
                {multiTasking ? (
                    <div class="list-control">
                        <table>
                            <tbody>
                                <td>
                                    <img src="assets/icons/arrow-turn-down-left.svg" class="list-control__icon main" />
                                </td>
                                {multiTasking.tasks.map((task, index) => (
                                    <td key={index}>
                                        <span
                                            role="button"
                                            onClick={() => task.onClick()}
                                            className={`bg-blur-${task.color} list-control__action`}
                                        >
                                            <img src={`assets/icons/${task.icon}.svg`} class="list-control__icon" />
                                            <span>{task.title}</span>
                                        </span>
                                    </td>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : null}

                <div class="list-pages">
                    <button
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                        class="list-pages__move"
                    >
                        <img src="assets/icons/arrow-right-long.svg" class="list-pages__icon" />
                        <span>قبلی</span>
                    </button>
                    <ul class="list-pages__numbers">
                        {getPageNumbers().map((page, index) => (
                            <li key={index}>
                                {page === "..." ? (
                                    <span class="list-pages__ellipsis">...</span>
                                ) : (
                                    <button
                                        onClick={() => setCurrentPage(page)}
                                        class={`list-pages__num ${page === currentPage ? "active" : ""}`}
                                    >
                                        {page}
                                    </button>
                                )}
                            </li>
                        ))}
                    </ul>
                    {/* if (currentPage == index + 1) {
                            return (
                                <li>
                                    <button
                                        onClick={() => {
                                            setCurrentPage(index + 1)
                                        }}
                                        class="list-pages__num active"
                                    >
                                        {index + 1}
                                    </button>
                                </li>
                            )
                        } else {
                            return (
                                <li>
                                    <button onClick={() => setCurrentPage(index + 1)} class="list-pages__num">
                                        {index + 1}
                                    </button>
                                </li>
                            )
                        } */}

                    <button
                        onClick={() => handlePageChange(currentPage + 1)}
                        className="px-4 py-2 border rounded bg-gray-200 hover:bg-gray-300"
                        disabled={currentPage === totalPages}
                        class="list-pages__move"
                    >
                        <span>بعدی</span>
                        <img src="assets/icons/arrow-left-long.svg" class="list-pages__icon" />
                    </button>
                </div>
            </div>
        </>
    )
}

export default Table
